/**
 * 라우트 통합 파일
 * 모든 라우트를 정의하고 통합하여 반환
 */
import { Navigate, Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';

import { getDevRoutes } from '../dev/dev.routes';
import { MainLayout } from '../layout/MainLayout';

import { authRoutes } from './auth.routes';
import { CheckAuth } from './components/CheckAuth';
import { ErrorBoundary } from './components/ErrorBoundary';
import { HydrateFallback } from './components/HydrateFallback';
import { mobileRoutes } from './mobile.routes';
import { patientRoutes } from './patient.routes';
import { paymentRoutes } from './payment.routes';
import { createLazyRoute } from './utils/createLazyRoute';

/**
 * 실험 페이지(/dev) 포함 여부. `VITE_ENABLE_DEV_PAGES=true`일 때만 true.
 * 이 값은 Vite가 빌드 시 정적 치환하므로, 꺼진 채 빌드하면 아래 getDevRoutes() 참조가
 * dead-code로 제거되어 dev.routes 및 실험 페이지 청크가 번들에서 완전히 빠진다.
 * (dev 모드에서만 로드되는 .env.development 에 플래그가 있어 프로덕션 빌드엔 미포함)
 */
const DEV_PAGES_ENABLED = import.meta.env.VITE_ENABLE_DEV_PAGES === 'true';

export const createAppRoutes = () => {
  return createBrowserRouter(
    createRoutesFromElements(
      <Route ErrorBoundary={ErrorBoundary} HydrateFallback={HydrateFallback}>
        {mobileRoutes}
        {authRoutes}

        {/* 개발용 실험 페이지(/dev). VITE_ENABLE_DEV_PAGES=true일 때만 포함, 빌드 시 tree-shaking 제외. */}
        {DEV_PAGES_ENABLED && getDevRoutes()}

        <Route
          element={
            <CheckAuth>
              <MainLayout />
            </CheckAuth>
          }>
          <Route path="dashboard" {...createLazyRoute(() => import('../pages/dashboard/org/DashboardContents'))} />
          <Route path="setting" {...createLazyRoute(() => import('../pages/setting/SettingPage'))} />
          <Route path="stim" {...createLazyRoute(() => import('../pages/stim/StimPage'))} />
          <Route path="somzz" {...createLazyRoute(() => import('../pages/somzz/SomzzPage'))} />
          {patientRoutes}
          {paymentRoutes}
          <Route path="/" element={<Navigate to={`/dashboard`} replace />} />
        </Route>
        <Route path="*" element={<Navigate to={`/`} replace />} />
      </Route>
    )
  );
};
